export class LoginBodyModel {
  email: string | null = null;
  password: string | null = null;

  constructor() {}
}
